// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__2aCw9","label":"Section_label__62iOP","contentWrap":"Section_contentWrap__2XOuY","footer":"Section_footer__ao6Qa","footerInner":"Section_footerInner__eAXWC"};